<template>
    <div class="d-flex flex-column">
        <div>
            <table class="table-widget w-auto" style="page-break-after: always">
                <tbody>
                    <tr v-for="(tr, trIndex) in item.data.table_data" :key="trIndex">
                        <td
                            v-for="(td, tdIndex) in tr.cells.filter((td) => !td.disabled)"
                            :id="`cell-index-${tdIndex}`"
                            :key="tdIndex"
                            :rowspan="td.style.row_span"
                            :colspan="td.style.col_span"
                            :style="{
                                width:
                                    td.style.width === 'auto' ? 7.5 / item.data.columns_count + 'in' : td.style.width + 'in',
                                height: td.style.height === 'auto' ? 0.6 + 'in' : td.style.height + 'in',
                                'background-color': td.style.background_color,
                                'border-width': getCellBorder(td.style.border_side),
                            }"
                            @click="getCellClick(trIndex + 1, tdIndex + 1)"
                        >
                            <TableCellItemPreview :item="td" :index="tdIndex" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import TableCellItemPreview from './TableCellItemPreview.vue'

export default defineComponent({
    name: 'TableWidgetPreview',
    components: {
        TableCellItemPreview,
    },
    props: {
        item: {
            type: Object,
            default: undefined,
        },
    },
    data() {
        return {
            widgetStatusTimeout: null,
        }
    },
    methods: {
        getCellBorder(borderSide: string): string {
            if (borderSide === 'all') {
                return '2px'
            } else if (borderSide === 'none') {
                return '1px'
            } else if (borderSide === 'top') {
                return '2px 0 0 0'
            } else if (borderSide === 'left') {
                return '0 0 0 2px'
            } else if (borderSide === 'right') {
                return '0 2px 0 0'
            } else if (borderSide === 'bottom') {
                return '0 0 2px 0'
            }
            return ''
        },
        getCellClick(row: number, col: number): void {
            this.$store.dispatch('document/setCurrentTableWidgetCell', { row, col })
        },
    },
})
</script>
